/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import { Box } from '@versumstudios/ui';

interface IPreviewComponent {
  value: string;
}

export const PreviewComponent: FC<IPreviewComponent> = ({ value }) => {
  return (
    <Box
      css={{
        padding: '$space$4',
        img: {
          height: 48,
          width: 'auto',
        },
      }}
      vertical
    >
      <img src={value} alt="image preview" />
    </Box>
  );
};
